interface DraggableIndicatorProps {
    style?: React.CSSProperties;
}

export const DraggableIndicator = ({ style }: DraggableIndicatorProps) => {
    return (<div 
        className="draggable-indicator" 
        style={{
            position: 'absolute',
            top: '20px',
            left: '20px',
            width: '16px',
            height: '16px',
            borderRadius: '50%',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '20px',
            fontWeight: 'bold',
            pointerEvents: 'none',
            zIndex: 10,
            ...style,
        }}
    >
        ⋮⋮
    </div>);
};